import { render, staticRenderFns } from "./submitted.vue?vue&type=template&id=1d3baa8e&scoped=true"
import script from "./submitted.vue?vue&type=script&lang=js"
export * from "./submitted.vue?vue&type=script&lang=js"
import style0 from "./submitted.vue?vue&type=style&index=0&id=1d3baa8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3baa8e",
  null
  
)

export default component.exports